import angular from 'angular';
import editLoanSubmissionEmailModal from './editLoanSubmissionEmailModal';
import './style.scss';

export default angular
  .module('components.editLoanSubmissionEmailModal', [])
  .component('editLoanSubmissionEmailModal', editLoanSubmissionEmailModal).name;
